<template>
  <div class="my-rights-page">
    <TabsRightType
      :options="rightTypeTabsOptions"
      :cur-tab="curTabRightType"
      @tabClick="handleTypeTabClick"
    />
    <TabsRight
      :options="option.rightTabsOptions"
      :cur-tab="curTabRight"
      @tabClick="handleTabClick"
    />

    <van-pull-refresh
      v-model="showPullRefreshLoading"
      @refresh="toFindPurchasedRight"
    >
      <div
        class="coupons"
        v-if="curTabRightType === 'coupon'"
      >
        <CouponCard
          class="coupon"
          v-for="(item, index) in rightList"
          :key="index"
          :value="item"
          :disabled="isDisabled"
          :is-used-list="isUsedList"
          @toCouponsDetail="toCouponsDetail"
          @goReport="goReport"
          @goToDetail="goToDetail"
        />
        <div
          v-if="!rightList.length"
          class="rights-blank"
        >
          <Blank text="暂无充电券权益" />
          <div
            v-if="curTabRight === 'waitUseList'"
            class="buy-coupon-btn"
            @click="toCharingCenterPage"
          >
            购买充电券
          </div>
        </div>
        <div
          v-if="$parent.showBottomNavBar"
          class="h-bottom-nav"
        />
      </div>
      <div
        class="cards"
        v-if="curTabRightType === 'card'"
      >
        <CardCard
          class="card"
          v-for="(item, index) in rightList"
          :key="index"
          :disabled="isDisabled"
          :value="item"
          @goToDetail="goToDetail"
        />
        <div
          v-if="!rightList.length"
          class="rights-blank"
        >
          <Blank text="暂无充电卡权益" />
          <div
            v-if="curTabRight === 'available'"
            class="buy-coupon-btn"
            @click="toCharingCenterPage"
          >
            购买充电卡
          </div>
        </div>
        <div
          v-if="$parent.showBottomNavBar"
          class="h-bottom-nav"
        />
      </div>
    </van-pull-refresh>

    <!-- 客服悬浮按钮 -->
    <CustomerServiceBtn />
    <!-- 广告弹窗 -->
    <AdWecomPopup ref="refAdWecomPopup" />
  </div>
</template>

<script>
import TabsRightType from '../../chargingVoucher/components/TabsRightType.vue';
import TabsRight from '../../chargingVoucher/components/TabsRight.vue';
import CouponCard from './CouponCard.vue';
import CardCard from './CardCard.vue';
import Blank from '../../chargingVoucher/components/Blank.vue';
import {
  findPurchasedRight,
  wxappOrderAddCount,
  findPurchasedRightCard
} from '../common/api.js';
import CustomerServiceBtn from '../../chargingVoucher/components/CustomerServiceBtn.vue';
import AdWecomPopup from './AdWecomPopup.vue';
import {
  toQueryWindowReminder,
  toSaveWindowReminder
} from '@/common/control-popup.js';

class CreateCouponInfo {
  waitUseList = []; // 待使用列表
  hasUsedList = []; // 已使用列表
  expiredList = []; // 已过期列表
}

class CreateCardInfo {
  available = []; // 可用权益
  unAvailable = []; // 不可用权益
}

export default {
  name: 'MyCoupons',
  components: {
    TabsRightType,
    TabsRight,
    CouponCard,
    CardCard,
    Blank,
    CustomerServiceBtn,
    AdWecomPopup
  },
  data() {
    return {
      curTabRightType: 'card',
      curTabRight: '',
      rightTypeTabsOptions: [
        {
          text: '充电卡权益',
          key: 'card',
          api: findPurchasedRightCard,
          info: new CreateCardInfo(),
          rightTabsOptions: [
            {
              text: '可用权益',
              key: 'available'
            },
            {
              text: '不可用权益',
              key: 'unAvailable'
            }
          ]
        },
        {
          text: '充电券权益',
          key: 'coupon',
          api: findPurchasedRight,
          info: new CreateCouponInfo(),
          rightTabsOptions: [
            {
              text: '待使用',
              key: 'waitUseList'
            },
            {
              text: '已使用',
              key: 'hasUsedList'
            },
            {
              text: '已过期',
              key: 'expiredList'
            }
          ]
        }
      ],
      rightList: [],
      showLoading: false,
      cardType: ['FL40000015', 'FL40000019'],
      showPullRefreshLoading: false
    };
  },
  computed: {
    isDisabled() {
      return !(
        this.curTabRight === 'waitUseList' || this.curTabRight === 'available'
      );
    },
    isUsedList() {
      return this.curTabRight === 'hasUsedList';
    },
    option() {
      const option =
        this.rightTypeTabsOptions.find(
          (item) => item.key === this.curTabRightType
        ) || {};
      return option;
    }
  },
  created() {
    const rightType = localStorage.getItem('_rightType') || '';
    if (rightType) {
      this.handleTypeTabClick(rightType);
      localStorage.removeItem('_rightType');
    } else {
      this.handleTypeTabClick(this.curTabRightType);
    }
  },
  methods: {
    handleTypeTabClick(key) {
      this.curTabRightType = key;
      this.rightList = [];
      this.curTabRight = this.option.rightTabsOptions[0].key;
      this.toFindPurchasedRight();
    },
    handleTabClick(key) {
      this.curTabRight = key;
      this.rightList = [];
      setTimeout(() => {
        if (!this.option.info) this.option.info = {};
        this.rightList = this.option.info[this.curTabRight] || [];
        if (this.curTabRightType === 'coupon') {
          this.rightList = this.rightList.filter((item) =>
            this.cardType.includes(item.productCategoryCode)
          );
        }
      }, 100);
    },
    toFindPurchasedRight() {
      const param = {
        purchasedRightType: '1',
        valid: '1'
      };
      this.showPullRefreshLoading = true;
      this.option
        .api(param)
        .then((res) => {
          if (res) {
            const data = res;
            this.option.info = data;
            this.handleTabClick(this.curTabRight);
          }
        })
        .finally(() => {
          setTimeout(() => {
            this.showPullRefreshLoading = false;
          }, 500);
        });
    },
    toCharingCenterPage() {
      if (this.$browserEnv == 0) {
        wx.miniProgram.switchTab({
          url: '/pages/home/home'
        });
      } else {
        this.$parent.curNav = 'CharingCenter';
      }
    },
    toCouponsDetail() {
      wx.miniProgram.navigateTo({
        url: '/pages/chargingVoucher/coupons-package-detail'
      });
    },
    goReport(data) {
      const param = {
        orderNo: data.orderNo,
        divChargeReportCount: 1
      };
      wxappOrderAddCount(param);

      wx.miniProgram.navigateTo({
        url: `/pages/report/index?orderNo=${data.orderNo}&channelCompanyNo=${data.channelCompanyNo}`
      });
    },
    goToDetail(data) {
      console.log('goToDetail', data);
      wx.miniProgram.navigateTo({
        url: `/pages/right/right-detail?rightRulePackageBindId=${data.rightRulePackageBindId}&companyNo=${data.companyNo}&useType=${this.curTabRight}`
      });
    },
    // 打开广告弹窗
    async handleOpenAdWecomPopup() {
      try {
        const isShow = await toQueryWindowReminder(2);
        if (isShow) {
          this.$refs.refAdWecomPopup.openPopup();
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 关闭广告弹窗
    handleCloseAdWecomPopup({ day }) {
      toSaveWindowReminder(2, day);
    }
  }
};
</script>

<style lang="scss" scoped>
.my-rights-page {
  min-height: calc(100vh - 114px);
  background: #f7f7f7;
  box-sizing: border-box;

  .coupons {
    box-sizing: border-box;
    min-height: calc(100vh - 114px);
    padding: 16px 32px 0px 32px;
  }
  .cards {
    box-sizing: border-box;
    min-height: calc(100vh - 114px);
    padding: 16px 32px 0px 32px;
  }
  .rights-blank {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    transform: translateY(20vh);

    .buy-coupon-btn {
      background: #fe7256;
      border-radius: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 32px;
      color: #ffffff;
      text-align: center;
      font-weight: 400;
      width: 320px;
      height: 90px;
      margin-top: 64px;
    }
  }
}
.h-bottom-nav {
  height: calc(98px + constant(safe-area-inset-bottom));
  height: calc(98px + env(safe-area-inset-bottom));
}
</style>
